<template>
  <XpWindow
    :title="t('xp.display.title')"
    icon="🖥️"
    :active="true"
    :minimized="false"
    :width="380"
    :body-height="null"
    @minimize="$emit('close')"
    @maximize="$emit('close')"
    @close="$emit('close')"
  >
    <div class="xp-font">
      <fieldset class="rounded border border-[#d4d0c8] p-3">
        <legend class="px-1 text-[12px] text-black">{{ t('xp.display.monitor') }}</legend>
        <label class="flex cursor-pointer items-start gap-2 text-[12px] text-black">
          <input
            v-model="pending"
            type="checkbox"
            class="mt-0.5 h-4 w-4 accent-[#0058e6]"
          />
          <span>{{ t('xp.crt.label') }}</span>
        </label>
      </fieldset>
      <div class="mt-3 flex justify-end gap-2">
        <button class="xp-raised xp-font px-4 py-1 text-[12px] text-black" @click="ok">
          {{ t('xp.display.ok') }}
        </button>
        <button class="xp-raised xp-font px-4 py-1 text-[12px] text-black" @click="$emit('close')">
          {{ t('xp.display.cancel') }}
        </button>
        <button
          class="xp-raised xp-font px-4 py-1 text-[12px] text-black disabled:opacity-40"
          :disabled="!dirty"
          @click="apply"
        >
          {{ t('xp.display.apply') }}
        </button>
      </div>
    </div>
  </XpWindow>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import XpWindow from './XpWindow.vue'
import { crtEnabled } from '../composables/useCrt'

const emit = defineEmits<{
  apply: [on: boolean]
  close: []
}>()

const { t } = useI18n()
const pending = ref(crtEnabled.value)
const dirty = ref(false)

watch(pending, () => {
  dirty.value = pending.value !== crtEnabled.value
})

function apply(): void {
  emit('apply', pending.value)
  dirty.value = false
}

function ok(): void {
  emit('apply', pending.value)
  emit('close')
}
</script>
